import { useApp } from '@common/hooks';
import { observer } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { NotificationToast } from './NotificationToast';



export const NotificationList = observer(() => {
    const { notifications } = useApp();
    const appRoot = document.getElementById('root');
    return (
        <>
            {appRoot && ReactDOM.createPortal(
                <div className="toast-container">
                    {notifications.notifications.map(([uuid, notification]) =>
                        <NotificationToast key={uuid} notification={notification} onClose={() => notifications.clearNotification(uuid)} />)
                    }
                </div>,
                appRoot
            )}
        </>
    );
});
